<template>
  <div class="sm:col-span-6 relative">
    <label :for="id" class="block text-sm font-medium text-gray-700 pb-1">{{
      labelText
    }}</label>
    <div class="flex grow-0 gap-4 flex-col sm:flex-row">
      <template v-for="(child, index) in children" :key="index">
        <select
          v-if="child.type === 'choice'"
          :id="getFormattedProperty(name, child.name)"
          v-model="child.value"
          :name="getFormattedProperty(name, child.name)"
          :required="required"
          class="input-primary mb-2 w-full"
          :class="[
            !errorMessage
              ? 'shadow-sm focus:border-bkk-100 focus:ring-bkk-100 sm:text-sm'
              : '!border-red-300 pr-10 border text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500 ',
            children.length < 3 ? 'sm:w-2/3' : 'sm:w-1/3',
          ]"
          @input="validate"
        >
          <option
            v-for="choice in child.choices"
            :key="choice.value"
            :value="choice.value"
          >
            {{ choice.label }}
          </option>
        </select>
        <input
          v-if="child.type === 'text'"
          :id="getFormattedProperty(name, child.name)"
          :key="index"
          v-model="child.value"
          :required="required"
          :name="getFormattedProperty(name, child.name)"
          :type="child.type"
          :placeholder="child.placeholder"
          class="input-primary mb-2 w-full sm:w-1/3"
          :class="[
            !errorMessage
              ? 'shadow-sm focus:border-bkk-100 focus:ring-bkk-100 sm:text-sm'
              : '!border-red-300 pr-10 border text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500 ',
          ]"
          :style="[
            child.placeholder && child.placeholder.length > 5
              ? 'padding-left: 1.5rem; padding-right: 1.5rem;'
              : '',
          ]"
          @input="validate"
        />
      </template>
    </div>
    <p v-if="errorMessage" class="mt-2 text-sm text-action-red">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: "CompoundElement",
  components: {},
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    children: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    errorKey: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "update-field"],
  data() {
    return {
      error: this.errorMessage,
    };
  },
  computed: {
    labelText() {
      return `${this.label} ${this.required ? "*" : ""}`;
    },
  },
  methods: {
    validate(event) {
      this.$emit("update-field", event.target.value);
    },
    getFormattedProperty(left, right) {
      return left + "[" + right + "]";
    },
  },
};
</script>
